"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk5XN3ONI2_js = require('./chunk-5XN3ONI2.js');
var chunkW3JFSNO3_js = require('./chunk-W3JFSNO3.js');
var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var A = require('react');
var a = require('styled-components');
var faXmark = require('@fortawesome/pro-solid-svg-icons/faXmark');
var faArrowLeft = require('@fortawesome/pro-solid-svg-icons/faArrowLeft');
var faUpDownLeftRight = require('@fortawesome/pro-solid-svg-icons/faUpDownLeftRight');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var A__default = /*#__PURE__*/_interopDefaultLegacy(A);
var a__default = /*#__PURE__*/_interopDefaultLegacy(a);

var c=a__default["default"](chunk5XN3ONI2_js.a).attrs({variant:"tertiary",iconOnly:!0})`
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  outline-offset: 0;
`,v=a__default["default"](c).attrs({children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faArrowLeft.faArrowLeft})})``,h=a__default["default"](c).attrs({children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faXmark.faXmark})})`
  ${chunkPBLNC4OF_js.b} {
    height: 20px;
  }
`,b=a__default["default"](c).attrs({children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faUpDownLeftRight.faUpDownLeftRight})})`
  cursor: ${({dragging:o})=>o?"grabbing":"grab"};
`;var R=`
  --header-background: var(--color-neutral-50);
  --header-foreground: var(--color-neutral-900);
  --header-divider: var(--color-neutral-200);

  --content-background: var(--color-neutral-0);

  [data-theme='dark'] & {
    --header-background: var(--color-neutral-950);
    --header-foreground: var(--color-neutral-50);
    --header-divider: var(--color-neutral-700);

    --content-background: var(--color-neutral-500);
  }
`,P=a__default["default"].div`
  ${R}

  border-radius: 12px;
  box-shadow: var(--elevation-300);
  overflow: hidden;
  min-width: 324px;
  width: fit-content;
`,y=a__default["default"].div`
  align-items: center;
  background-color: var(--header-background);
  border-bottom: 1px solid var(--header-divider);
  display: flex;
  justify-content: space-between;
  height: 41px;
  padding: 0 var(--spacing-small);

  :hover {
    ${({isDraggable:o})=>o&&a.css`
        cursor: grab;
      `}
  }

  ${chunkW3JFSNO3_js.b} {
    color: var(--header-foreground);
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-semibold);
    margin-left: var(--spacing-small);
  }

  ${chunkPBLNC4OF_js.b} {
    color: var(--header-foreground);
  }
`,B=a__default["default"].div`
  align-items: center;
  display: flex;
`,w=a__default["default"].div`
  display: flex;
  flex-wrap: no-wrap;
`,g=a__default["default"].div`
  background: var(--content-background);
  color: var(--foreground-primary);
  font-size: var(--font-size-small);
  height: 100%;
  overflow-y: auto;
  padding: var(--spacing-regular);

  // this is to prevent the content from being cut off
  // when the window is resized to be smaller than the content
  ${({top:o=0,innerOffset:e=0})=>a.css`
    max-height: calc(100vh - ${e}px - ${o}px);
  `}
`;var F=A__default["default"].forwardRef(({children:o,...e},n)=>jsxRuntime.jsx(P,{ref:n,role:"dialog",...e,children:o})),T=({title:o,onBack:e,showBack:n,onDismiss:u,dragHandlers:d,isHeaderDraggable:s=!1})=>jsxRuntime.jsxs(y,{...s?d:{},isDraggable:s,children:[jsxRuntime.jsxs(B,{children:[n&&jsxRuntime.jsx(v,{onClick:e,"aria-label":"Return to previous panel"}),jsxRuntime.jsx(chunkW3JFSNO3_js.b,{children:o})]}),jsxRuntime.jsxs(w,{children:[d&&jsxRuntime.jsx(b,{...s?{}:d,"aria-label":"Drag to move"}),u&&jsxRuntime.jsx(h,{onClick:u,"aria-label":"Close"})]})]}),$=({innerOffset:o,top:e,children:n})=>jsxRuntime.jsx(g,{innerOffset:o,top:e,children:n}),D={Root:F,Header:T,Body:$,Content:g};

exports.a = D;
